<template>
    <section class="h-full w-full flex flex-col bg-white rounded-2xl border shadow-lg p-6 md:p-8">
        <div class="flex justify-between">
            <h1 class="text-base md:text-lg font-semibold">Users</h1>
        </div>

        <div class="h-full flex justify-center items-center" v-if="$apollo.queries.alumniList.loading">
            <base-spinner></base-spinner>
        </div>
        <div v-else-if="!$apollo.queries.alumniList.loading && filteredAlumniList.length <= 0"
            class="h-full flex justify-center items-center">
            <h1 class="text-center text-xl font-medium">No users found!</h1>
        </div>
        <div v-else class="flex flex-col mt-4">
            <div class="flex flex-col overflow-x-auto">
                <div class="inline-block min-w-full py-2">
                    <div class="overflow-x-auto">
                        <table class="min-w-full text-left text-sm font-light">
                            <thead class="border-b font-medium dark:border-neutral-500">
                                <tr>
                                    <th scope="col" class="px-6 py-4 text-gray-400 w-8">#</th>
                                    <th scope="col" class="px-6 py-4 text-gray-400">Name</th>
                                    <th scope="col" class="px-6 py-4 text-gray-400">School ID</th>
                                    <th scope="col" class="px-6 py-4 text-gray-400">Graduated Year</th>
                                    <th scope="col" class="px-6 py-4 text-gray-400">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(alumni, index) in filteredAlumniList" :key="index"
                                    class="border-b border-dashed dark:border-neutral-500">
                                    <td class="whitespace-nowrap px-6 py-4 font-medium">{{ paginatorInfo.firstItem +
                                        index }}</td>
                                    <td class="whitespace-nowrap px-6 py-4">
                                        <div class="flex items-center">
                                            <div class="flex-shrink-0 mr-3">
                                                <img class="h-12 w-12 rounded-lg object-cover"
                                                    :src="getProfilePicture(alumni.profile_picture_url)" alt="">
                                            </div>
                                            <div class="flex-grow flex flex-col">
                                                <h1 class="text-sm font-semibold flex items-center">
                                                    <span>{{ alumni.english_name }}</span>
                                                    <span v-if="alumni.is_verified_by_career_counselor"
                                                        class="ml-1 h-3 w-3 rounded-full bg-blue-600 flex items-center justify-center">
                                                        <icon-check class="w-2 h-2 text-white"></icon-check>
                                                    </span>
                                                </h1>
                                                <p class="text-xs text-gray-400">{{ alumni.student_id }}</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="whitespace-nowrap px-6 py-4">{{ alumni.school_id }}</td>
                                    <td class="whitespace-nowrap px-6 py-4">{{ alumni.graduated_year }}</td>
                                    <td class="px-6 py-4">
                                        <div class="flex">
                                            <div @click.stop="viewAlumniUser(alumni.id, alumni.english_name)"
                                                class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer mr-2">
                                                <icon-eye
                                                    class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-eye>
                                            </div>
                                            <!-- <div @click.stop="editAlumniUser(alumni.id, alumni.english_name)" class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer mr-2">
                                            <icon-pen class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-pen>
                                        </div>
                                        <div class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer">
                                            <icon-trash class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-trash>
                                        </div> -->
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="mt-4">
                <pagination :paginatorInfo="paginatorInfo" :setPage="setPage"></pagination>
            </div>
        </div>

        <transition name="fade" mode="out-in">
            <base-modal v-if="openViewAlumniUserModal" :title="`Alumni Form - ${viewAlumniUserModaltitle}`"
                height="90vh" @close="closeViewAlumniUserModal">
                <employment-users-view :alumni-user-id="alumniUserId"></employment-users-view>
            </base-modal>
        </transition>

    </section>
</template>

<script>
import IconEye from "../../../components/icons/IconEye.vue";
// import IconPen from "../../../components/icons/IconPen.vue";
// import IconTrash from "../../../components/icons/IconTrash.vue";
// import IconPlus from "../../../components/icons/IconPlus.vue";
import IconCheck from "../../../components/icons/IconCheck.vue";
import gql from 'graphql-tag';
import Pagination from "../../../components/shared/pagination.vue";
// import EmploymentUsersForm from "./users/form.vue";
import EmploymentUsersView from "./users/view.vue";
export default {
    name: "employment-supervisor-users",
    components: {
        IconEye,
        // IconPen,
        // IconTrash,
        // IconPlus,
        IconCheck,
        Pagination,
        // EmploymentUsersForm,
        EmploymentUsersView,
    },
    data() {
        return {
            alumniList: [],
            first: 5,
            page: 1,
            openViewAlumniUserModal: false,
            viewAlumniUserModaltitle: "",
            alumniUserId: null,
        };
    },
    computed: {
        filteredAlumniList() {
            return this.alumniList.data;
        },
        paginatorInfo() {
            return this.alumniList.paginatorInfo;
        },
    },
    apollo: {
        alumniList() {
            return {
                query: gql`query AllUsers($first: Int!, $page: Int!) {
                    alumniList(first: $first, page: $page) {
                        data {
                            id
                            english_name
                            student_id
                            school_id
                            graduated_year
                            profile_picture_url
                            is_verified_by_career_counselor
                        }
                        paginatorInfo {
                            count
                            currentPage
                            firstItem
                            hasMorePages
                            lastItem
                            lastPage
                            perPage
                            total
                        }
                    }
                }`,
                variables() {
                    return {
                        first: this.first,
                        page: this.page,
                    }
                },
                fetchPolicy: 'cache-and-network'
            }
        },
    },
    methods: {
        setPage(page) {
            this.page = page;
        },
        onAddAlumniUser() {
            this.$apollo.queries.alumniList.refetch();
            this.closeModal();
        },
        viewAlumniUser(id, name) {
            this.alumniUserId = id;
            this.viewAlumniUserModaltitle = name;
            this.openViewAlumniUserModal = true;
        },
        closeViewAlumniUserModal() {
            this.openViewAlumniUserModal = false;
            this.viewAlumniUserModaltitle = "";
            this.alumniUserId = null;
        },
        editAlumniUser(id, name) {
            console.log(id, name);
        },
        getProfilePicture(profilePictureUrl) {
            return process.env.VUE_APP_PUBLIC_URL + profilePictureUrl;
        },
    },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>